export default "__VITE_ASSET__dab1584f__"